/**
 * Client-side mirror of the backend password policy (app/api/password_policy.py).
 *
 * This exists for user experience only: it surfaces the requirement up front and
 * catches a short password before a round trip. It is NOT a security control,
 * because anything enforced here can be bypassed by calling the API directly.
 * The backend is the authority and re-validates every password it is given.
 *
 * Keep MIN_PASSWORD_LENGTH in sync with PASSWORD_MIN_LENGTH on the API. Set
 * REACT_APP_PASSWORD_MIN_LENGTH at build time when overriding the default.
 */
const parsedMinLength = parseInt(process.env.REACT_APP_PASSWORD_MIN_LENGTH, 10);

export const MIN_PASSWORD_LENGTH = Number.isNaN(parsedMinLength) ? 12 : parsedMinLength;

// bcrypt on the API side truncates at 72 bytes, so longer input is rejected there.
export const MAX_PASSWORD_BYTES = 72;

export const PASSWORD_REQUIREMENTS_TEXT = `At least ${MIN_PASSWORD_LENGTH} characters`;

/**
 * Returns an error message when the password fails policy, or null when it passes.
 */
export function validatePassword(password) {
  if (!password) {
    return 'Password is required';
  }
  if (password.length < MIN_PASSWORD_LENGTH) {
    return `Password must be at least ${MIN_PASSWORD_LENGTH} characters long`;
  }
  // Match the API's byte-based ceiling rather than counting characters.
  if (new TextEncoder().encode(password).length > MAX_PASSWORD_BYTES) {
    return `Password must be ${MAX_PASSWORD_BYTES} bytes or fewer (roughly 72 standard characters)`;
  }
  return null;
}
